// Status metadata for the Coachability Console.
// UI "assessment" = backend Survey; participant row = backend Assessment
// (see Backend Reconciliation §01). Colors are design tokens only.

export const ASSESSMENT_STATUS = {
  complete:  { label: 'Complete',    fg: 'var(--science-700)', ring: 'var(--science-500)', fill: 'var(--science-400)', soft: 'var(--science-100)' },
  active:    { label: 'In progress', fg: 'var(--neutral-900)', ring: 'var(--gfx-gold)',    fill: 'var(--gfx-gold)',    soft: 'var(--gfx-butter)' },
  scheduled: { label: 'Scheduled',   fg: 'var(--human-700)',   ring: 'var(--human-400)',   fill: 'var(--human-400)',   soft: 'var(--human-50)' },
  locked:    { label: 'Locked',      fg: 'var(--ink-faint)',   ring: 'var(--neutral-200)', fill: 'var(--neutral-200)', soft: 'var(--neutral-50)' },
};

export const PSTATUS = {
  complete:      { label: 'Completed',   dot: 'var(--science-500)' },
  active:        { label: 'In progress', dot: 'var(--gfx-gold)' },
  'not-started': { label: 'Not started', dot: 'var(--neutral-300)' },
  disabled:      { label: 'Disabled',    dot: 'var(--human-500)' },
};

export const ENGAGEMENT_STATUS = {
  active:    { label: 'Active',   fg: 'var(--science-700)', bg: 'var(--science-100)', live: true },
  completed: { label: 'Complete', fg: '#fff',               bg: 'var(--neutral-900)', live: false },
  archived:  { label: 'Archived', fg: 'var(--ink-muted)',   bg: 'var(--neutral-100)', live: false },
};
